import React, { useEffect, useState } from "react";
import { db } from "./firebase";
import { ref, get } from "firebase/database";

export default function News() {
  function checkForRefresh() {
    if (performance.navigation.type === 1) {
        // La pagina è stata ricaricata manualmente, quindi esegui il reindirizzamento
        window.location.href = "https://www.centrozeta.it";
    }
}
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const query = ref(db, "News");
    const getData = async () => {
      try {
        const snapshot = await get(query);
        if (snapshot.val() !== null) {
          const data = snapshot.val();
          const newsArray = Object.values(data);
          const reversedNews = [...newsArray].reverse();
          setNews(reversedNews);
          setLoading(false); // Imposta il loading a "false" dopo il caricamento
        } else {
          console.log("Nessun dato trovato");
          setLoading(false); // Imposta il loading a "false" anche in caso di dati non trovati
        }
      } catch (error) {
        console.error("Errore nel recupero dei dati:", error);
        setLoading(false); // Imposta il loading a "false" in caso di errore
      }
    };

    getData();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 4;

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = news.slice(indexOfFirstPost, indexOfLastPost);

  const nextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    setCurrentPage(currentPage - 1);
  };

  return (
    <div className="App" onload={checkForRefresh()}>
      {loading ? (
        // Mostra il loader durante il caricamento
        <div className="loader" style={{marginBottom:'15rem', marginLeft:'9.7rem', marginTop:'15rem'}}>Caricamento in corso...</div>
      ) : (
        <div>
          {currentPosts.map((newsItem, index) => (
            <div className="post" key={index}>
              <h1 className="post-title">{newsItem.Titolo}</h1>
              {newsItem.Copertina && (
                <img
                  src={newsItem.Copertina}
                  alt="Immagine del Post"
                  className="post-image"
                />
              )}
              {newsItem.Testo && (
                <p className="post-text">{newsItem.Testo}</p>
              )}
            </div>
          ))}
        </div>
      )}
      <div className="pagination">
        <button
          className="transparent-button"
          onClick={prevPage}
          disabled={currentPage === 1}
        >
          Pagina precedente
        </button>
        <button
          className="transparent-button"
          onClick={nextPage}
          disabled={indexOfLastPost >= news.length}
        >
          Pagina successiva
        </button>
      </div>
    </div>
  );
}
